import { OwcButton, OwcModalDialog, OwcProgressSpinner, OwcTypography } from "@one/react";
import DocumentationViewSection from "./DocumentationViewSection";
import { EquipmentDetailsDisplay } from "../../components/shared/CommonPopOverModal/EquipmentDetailsDisplay";

const DocumentationModal = ({ visible, onClose, equipmentDetails, documents, loading = false }) => (
  <OwcModalDialog
    disableScrollLock
    visible={visible}
    size="lg"
    className="owcmodalZIndex"
    onVisibleChange={(e) => {
      e.stopPropagation();
      if (!e.target.visible) onClose(e);
    }}
  >
    <div slot="header">
      <OwcTypography variant="button">
        Documentation
      </OwcTypography>
    </div>

    {loading ? (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
        <OwcProgressSpinner diameter={60} />
      </div>
    ) : (
      <>
        {equipmentDetails && <EquipmentDetailsDisplay equipmentDetails={equipmentDetails} />}
        <DocumentationViewSection checklists={documents} />
      </>
    )}

    <div slot="actions" style={{ marginLeft: "auto", display: "flex", justifyContent: "end" }}>
      <OwcButton variant="secondary" onClick={onClose}>
        Close
      </OwcButton>
    </div>
  </OwcModalDialog>
);

export default DocumentationModal;
